<template>
  <v-dialog v-model="dialogShow" persistent max-width="540">
    <v-card>
      <v-card-title class="tipsDialog-title">
        温馨提示
        <v-spacer></v-spacer>
        <p @click="hideDialog" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text class="tipsDialog-mainArea">
        <div style="display:flex;align-items:center">
          <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
          <p class="tipsDialog-mainArea-text">{{dialogText}}</p>
        </div>
        <div class="tipsDialog-mainArea-btnLine">
          <v-btn @click="hideDialog" width="100" height="35" color="#F5F5F5">取消</v-btn>
          <v-btn @click="quitPageOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "QuitPageDialog",
  props:["quitPageNextPage","dialogShow","dialogText"],
  methods:{
    quitPageOK(){
      switch(this.quitPageNextPage){
        case "home":{
          this.$router.push({
            path:'/globe'
          })
          break;
        }
        case "notice":{
          this.$router.push({
            path:'/home',query: {goHome:'goHome',intoNotice:'1'}
          })
          break;
        }
        case "userCenter":{
          // this.$router.push({
          //   path:'/home',query: {goHome:'goUserCenter'}
          // })
          this.$router.push({
            path:'/userCenter'
          })
          break;
        }
        case "quitLogin":{
          this.$utils.quitLogin();
          break;
        }
        case "close":{
          window.opener=null;
          window.open('','_self');
          window.close();
          break;
        }
        case "author":{
          this.$router.push({
            path:'/home',query: {goHome:'goHome'}
          })
          break;
        }


      }
      this.hideDialog();

    },

    //隐藏弹窗
    hideDialog(){
      this.$emit("hideQuitPageDialog")
    }
  },

}
</script>

<style scoped>

</style>
